export const clientId = "5j6k0c1gbnt1582x5mngr14e7aqu9wbf";
export const clientSecret = "vXl0W10KIAVpHogr1Ce5IwyuHg0EZi8B";
export const grantType = "authorization_code";